module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-250-Active-Rumble-8837e234b76cd3253bcb857cd6944f50.png";